import devEn from './dev__en.json';
import devFr from './dev__fr.json';
import ecoReportEn from './eco_report__en.json';
import ecoReportFr from './eco_report__fr.json';
import en from './en.json';
import fr from './fr.json';
import momentEn from './moment__en.json';
import momentFr from './moment__fr.json';
import projectsEn from './projects__en.json';
import projectsFr from './projects__fr.json';
import scenarioEn from './scenario__en.json';
import scenarioFr from './scenario__fr.json';
import techReportEn from './tech_report__en.json';
import techReportFr from './tech_report__fr.json';
import unitsEn from './units__en.json';
import unitsFr from './units__fr.json';

export const locales: {[index: string]: any} = {
  './dev__en.json': devEn,
  './dev__fr.json': devFr,
  './eco_report__en.json': ecoReportEn,
  './eco_report__fr.json': ecoReportFr,
  './en.json': en,
  './fr.json': fr,
  './moment__en.json': momentEn,
  './moment__fr.json': momentFr,
  './projects__en.json': projectsEn,
  './projects__fr.json': projectsFr,
  './scenario__en.json': scenarioEn,
  './scenario__fr.json': scenarioFr,
  './tech_report__en.json': techReportEn,
  './tech_report__fr.json': techReportFr,
  './units__en.json': unitsEn,
  './units__fr.json': unitsFr
};
